import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'VOICE': {
      'ENABLE': 'Audiospuren für die Umfrage aktivieren',
      'TITULO': 'Spracheinstellungen',
      'SUBTITULO': 'Diese Einstellung wird nur angewendet, wenn die Audiospuren für die Umfrage aktiviert sind.',
      'CONFIG_IDIOMA': {
        'TITULO': 'Aktuelle Einstellungen für diese Sprache',
        'GENERO': {
          'TITULO': 'Stimme Geschlecht',
          'Femenino': 'Weiblich',
          'Masculino': 'Männlich'
        },
        'TIPO_VOZ': {
          'TITULO': 'Art der Stimme',
          '1': 'Sprachtyp 1',
          '2': 'Sprachtyp 2',
          '3': 'Sprachtyp 3',
          '4': 'Sprachtyp 4',
          '5': 'Sprachtyp 5',
          '6': 'Sprachtyp 6',
          '7': 'Sprachtyp 7',
          '8': 'Sprachtyp 8',
          '9': 'Sprachtyp 9',
          '10': 'Sprachtyp 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Sprachtest',
          'INSTRUCCION': 'Schreiben Sie einen Text, um die Stimme zu testen',
          'PLACEHOLDER': 'Sprachtesttext',
          'PROBAR': 'Text-to-Speech testen'
        }
      },
      'MODALES': {
        'COMPLETAR': 'Sind Sie sicher, dass Sie den Schritt mit der aktuellen Stimmenauswahl abgeschlossen haben?',
        'COMPLETAR_OFF': 'Möchten Sie den Schritt wirklich mit deaktivierten Spracheinstellungen abschließen?',
        'INCOMPLETO': 'Sie haben noch nicht die vollständige Auswahl der Stimmen in allen Sprachen getroffen. Sie müssen sie vervollständigen, um fortzufahren',
        'PASO_COMPLETO': 'Schritt erfolgreich abgeschlossen',
        'GENERANDO_AUDIOS': 'Die Spracheinstellungen werden auf Abschnitte dieses Produkts angewendet, bitte warten Sie einen Moment'
      }
    }
  }
};
